import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { markContingentManual } from '../ContingentDucks';
import { useTranslation } from 'react-i18next';

export default function ContingentApproveModalByParents({ open, onClose, checkedList, reportList,filter,setCheckedList }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const selectedChildren = reportList.filter(
    (item) => checkedList.includes(String(item.childId ?? item.staffId))
  );

  const handleApprove = () => {
    if (!selectedChildren.length) return;
    const childIds = selectedChildren.map(item => item.childId ?? item.staffId);
    dispatch(markContingentManual(childIds, onClose,filter,setCheckedList));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>{t('contingentPage_chosenChild')}</DialogTitle>

      <DialogContent dividers>
        {selectedChildren.length === 0 ? (
          <Typography color="textSecondary">
            {t('contingentPage_notChosenChild')}
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 600 }}>ID</TableCell>
                <TableCell style={{ fontWeight: 600 }}>{t('pageReport_fullName')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_visitedDays')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_withReason')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_reference')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_applicationLeave')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_statementParents')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_technicalError')}</TableCell>
                <TableCell style={{ fontWeight: 600, textAlign: 'center' }}>{t('pageReport_childrenDays')}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {selectedChildren.map((child, idx) => (
                <TableRow key={idx}>
                  <TableCell>{child.childId || child.staffId}</TableCell>
                  <TableCell>
                    {`${child.surname || ''} ${child.name || ''} ${child.middlename || ''}`}
                  </TableCell>
                  <TableCell align="center">{child.visitedDays}</TableCell>
                  <TableCell align="center">{child.unvisitedDaysWithoutReason}</TableCell>
                  <TableCell align="center">{child.unvisitedDaysWithReasonReference}</TableCell>
                  <TableCell align="center">{child.unvisitedDaysWithReasonLeaveApplication}</TableCell>
                  <TableCell align="center">{child.unvisitedDaysWithReasonParentStatement}</TableCell>
                  <TableCell align="center">{child.unvisitedDaysWithReasonTechnicalError}</TableCell>
                  <TableCell align="center">{child.childDays}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t('contingentPage_cancel')}
        </Button>
        <Button
          onClick={handleApprove}
          color="primary"
          variant="contained"
          disabled={selectedChildren.length === 0}
        >
          {t('contingentPage_approve')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
